import request from "@/axios";

// 获取企业的jsapi_ticket
export const getConfigTicket = async () => {
  return request.get({
    url: "/api/weChat/getJsapiTicket",
  });
};

// 获取应用的jsapi_ticket
export const getTicket = async () => {
  return request.get({
    url: "/api/weChat/getTicket",
  });
};

interface TypeGetSignature {
  url: String;
  jsapiTicket: String;
}
// 获取URL签名
export const getConfigGetSignature = async (params: TypeGetSignature) => {
  return request.get({
    url: "/api/weChat/getSignature",
    params,
  });
};
